module.exports = __webpack_public_path__ + "img/paypal.a5c522fb.png";